import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { kioskoStartGuard } from './guards/kiosko-start.guard';

export const routes: Routes = [
  {
    path: 'grupos',
    loadComponent: () => import('./pages/grupos.page/grupos.page').then(m => m.GruposPage)
  },
  {
    path: 'grupos/:grupoId/tramites',
    loadComponent: () => import('./pages/tramites.page/tramites.page').then(m => m.TramitesPage)
  },
  {
    path: 'tramites/:tramiteId',
    loadComponent: () => import('./pages/tramite.page/tramite.page').then(m => m.TramitePage)
  },
  {
    path: 'tramites/:tramiteId/nuevo-turno',
    loadComponent: () => import('./pages/nuevo-turno.page/nuevo-turno.page').then(m => m.NuevoTurnoPage)
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin.page/admin.page').then(m => m.AdminPage)
  },
  {
    path: 'tramites',
    loadComponent: () => import('./pages/v2/ciudadano-v2.page/ciudadano-v2.page').then(m => m.CiudadanoV2Page)
  },
  {
    path: 'instalar',
    loadComponent: () => import('./pages/v2/instalar.page/instalar.page').then(m => m.V2InstalarPage)
  },
  {
    path: 'v2',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/v2/shell.page/shell.page').then(m => m.V2ShellPage),
    children: [
      { path: '', redirectTo: 'inicio', pathMatch: 'full' },
      { path: 'inicio', canActivate: [kioskoStartGuard], loadComponent: () => import('./pages/v2/inicio.page/inicio.page').then(m => m.V2InicioPage) },
      { path: 'intencion', loadComponent: () => import('./pages/v2/intencion.page/intencion.page').then(m => m.V2IntencionPage) },
      { path: 'atencion-asistida', loadComponent: () => import('./pages/v2/atencion-asistida.page/atencion-asistida.page').then(m => m.V2AtencionAsistidaPage) },
      { path: 'grupos/:grupoId/tramites', loadComponent: () => import('./pages/v2/lista-tramites.page/lista-tramites.page').then(m => m.V2ListaTramitesPage) },
      { path: 'tramites/:tramiteId/confirmar', loadComponent: () => import('./pages/v2/confirmar-turno.page/confirmar-turno.page').then(m => m.V2ConfirmarTurnoPage) },
      { path: 'turno-generado', loadComponent: () => import('./pages/v2/turno-generado.page/turno-generado.page').then(m => m.V2TurnoGeneradoPage) },
      { path: 'citas', loadComponent: () => import('./pages/v2/citas-checkin.page/citas-checkin.page').then(m => m.V2CitasCheckinPage) },
      { path: 'configuracion-impresora', loadComponent: () => import('./pages/v2/printer-config.page/printer-config.page').then(m => m.PrinterConfigPage) },
    ]
  },
  { path: '', redirectTo: 'v2/inicio', pathMatch: 'full' },
  {
    path: '**',
    redirectTo: 'admin'
  }
];
